export default __webpack_public_path__ + "bfff080267ffd2759e0c38e67c4d54aa.png";